import React from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import SvgIcon from "../../../../parts/SvgIcon";

const MasterFoodLibraryTable = ({ data = [] }) => {
  /**
   * Open edit modal
   */
  const handleOpenModal = (_id) => {
    const body = { "modal[type]": "handle-meal-planner-food", foodId: _id };

    submit(`/actions/refresh/?`, {
      method: "GET",
      body,
    });
  };

  /**
   * Delete food
   * @param {*} e
   * @param {*} _id
   */
  const deleteFood = (e, _id) => {
    e.preventDefault();

    submit(`/actions/meal-planner/delete-master-food-library/${_id}/food`, {
      method: "GET",
    });
  };

  return (
    <section className="meal-table" data-scrollable="true" role="table-wrapper">
      <table>
        <thead>
          <tr>
            <th className="big">Food Name</th>
            <th className="medium">Brand Name</th>
            <th className="medium">Quantity</th>
            <th className="medium">Measurements</th>
            <th className="small">Proteins</th>
            <th className="small">Carbs</th>
            <th className="small">Fats</th>
            <th className="medium">kCal</th>
            <th className="medium">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map(
            ({
              brand = "",
              name = "",
              calories = 0,
              carbs = 0,
              fats = 0,
              measurementsValue = 1,
              proteins = 0,
              quantityDescription = "serving",
              quantityNumber = 1,
              unitOfMeasure = "g",
              _id,
            }) => (
              <tr key={_id}>
                <td>{name}</td>
                <td>{brand}</td>
                <td>
                  {quantityNumber} {quantityDescription}
                </td>
                <td>
                  {measurementsValue} {unitOfMeasure}
                </td>
                <td>{proteins}</td>
                <td>{carbs}</td>
                <td>{fats}</td>
                <td>{calories}</td>
                <td>
                  <div className="actions">
                    <button
                      data-button-type="outline"
                      onClick={() => handleOpenModal(_id)}
                    >
                      <span>Edit</span>
                    </button>
                    <button data-button-type="secondary" data-icon-only>
                      <SvgIcon
                        src="/img/new-icons/red-trash.svg"
                        onClickFn={(e) => deleteFood(e, _id)}
                        noFilterOnLight={true}
                      />
                    </button>
                  </div>
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </section>
  );
};

MasterFoodLibraryTable.propTypes = {
  data: PropTypes.array,
};

export default MasterFoodLibraryTable;
